import {
  AdditionalInfoIcons,
  Meal,
  Room,
  RoomRate,
} from "@beds2b-group/reusable-components/dist/types";
import { Policy } from "../models/booking/PerformBooking";
import { Hotel, RoomStaticData, Image } from "../models/availability/Commons";
import {
  additionalInfo,
  AlertType,
  CancellationPolicy,
  HotelAvailabilityResponse,
  PriceModifier,
  RoomAvailability,
  DepositType
} from "../models/availability/HotelAvailability";
import { RoomCard } from "@beds2b-group/reusable-components";
import { RegimeDto, RoomDto, ServiceDto } from "../models/AppConfig";
import dayjs, { Dayjs } from "dayjs";
import { getRoomErrorRibbon } from "./availabilityErrors";


export function HotelsToAppAvailability(
  hotelAvailability: HotelAvailabilityResponse,
  actualStepRoomSelector: number,
  onSelectRoom: (roomData: any, mealData: any, rateData: any) => void,
  modal: any,
  checkIn: Dayjs,
  checkOut: Dayjs,
  rooms: RoomDto[],
  regimes: RegimeDto[],
  allServices: ServiceDto[],
  selectedRoomsByIndex: Record<number, string>,
  userCurrency: any,
  doExchangeCurrency: (fromCurrency: string, toCurrency: string, amount: number) => number,
  language: string,
  roomHotelIds: string[],
  regimesHotelIds: string[],
  setOriginalCurrency: (currency: string) => void

): JSX.Element[] {
  let result: JSX.Element[] = [];

  let hotelCode: string = '';

  const availabilityData: RoomAvailability[] = [];
  const errorRoomsData: RoomAvailability[] = []; // habitaciones del paso actual con errorCode (no reservables)
  let currencySet = false;




  var availabilityWithoutErrors = hotelAvailability.hotelAvailabilities.filter(
    (hotelAvailability) => {
      return (hotelAvailability.errorCode ?? "").length == 0;
    }
  );


  availabilityWithoutErrors.forEach((hotelAvailability) => {
    hotelCode = hotelAvailability.hotelCode;

    if ((hotelAvailability.errorCode ?? "") === "") { // solo mostramos los que  no tengan errorCode
      hotelAvailability?.roomAvailabilities?.forEach((roomAvailability) => {
        const parsedRoomIndex = Number.parseInt(String(roomAvailability.roomIndex));
        if (parsedRoomIndex === actualStepRoomSelector) {
          // las habitaciones con errorCode se pintan aparte, deshabilitadas y con ribbon
          if ((roomAvailability.errorCode ?? "") === "") {
            availabilityData.push(roomAvailability);
          } else {
            errorRoomsData.push(roomAvailability);
          }
        }
      });
    }
  });

  availabilityData
    .filter((roomAvailability: RoomAvailability) => {
      // Filtrar los rates que tienen al menos una meal con currency válido
      // y si no tiene ....  niguna rate, no mostrar
      const hasValidRates = (roomAvailability.rates ?? []).some((rateInfo) =>
        rateInfo.meals.some((meal) => {
          if (!currencySet) {
            let c = meal.price?.pvpPrice?.currencyIsoCode ?? meal.price?.netPrice?.currencyIsoCode ?? "";
            if (c !== '') {
              setOriginalCurrency(c);
              currencySet = true;
            }
          }

          const pvpCurrency = meal.price?.pvpPrice?.currencyIsoCode ?? "";
          const netCurrency = meal.price?.netPrice?.currencyIsoCode ?? "";
          return pvpCurrency !== "" || netCurrency !== "";
        })
      );
      return hasValidRates;
    })
    .forEach((roomAvailability: RoomAvailability, _index: number) => {


      const hotelData: Hotel | undefined = hotelAvailability.hotels?.find(
        (hotel) => {
          return hotel.code == hotelCode;
        }
      );

      const staticHotelData = hotelData?.hotelStaticData?.[0];


      const staticRoomData = staticHotelData?.rooms.find(
        (room: RoomStaticData) => {
          return room.code == roomAvailability.roomCode;
        }
      );


      const staticRoomImages: string[] = staticRoomData?.images?.sort((i1, i2) => i1.order - i2.order).map((image: Image) => image.url ?? "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg") || ["https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"];

      let priceRoomFrom = Number.MAX_SAFE_INTEGER;
      let priceFrom = Number.MAX_SAFE_INTEGER;
      let currency = "";

      console.log("Room Availability:", roomAvailability);

      const rates: Array<RoomRate> = roomAvailability.rates
        .filter((rateInfo) => {
          const hasValidCurrency = rateInfo.meals?.some(meal => {
            const pvpCurrency = meal.price?.pvpPrice?.currencyIsoCode ?? "";
            const netCurrency = meal.price?.netPrice?.currencyIsoCode ?? "";
            if (!currencySet) {
              let c = meal.price?.pvpPrice?.currencyIsoCode ?? meal.price?.netPrice?.currencyIsoCode ?? "";
              if (c !== '') {
                setOriginalCurrency(c);
                currencySet = true;
              }
            }
            return pvpCurrency !== "" || netCurrency !== "";
          });
          return hasValidCurrency;
        })
        .map((rateInfo) => {


          let meals: Array<Meal> = [];
          rateInfo.meals
            .sort((a, b) => {
              const aAmt = a?.price?.pvpPrice?.amount ?? a?.price?.netPrice?.amount ?? Number.MAX_SAFE_INTEGER;
              const bAmt = b?.price?.pvpPrice?.amount ?? b?.price?.netPrice?.amount ?? Number.MAX_SAFE_INTEGER;
              return aAmt - bAmt;
            })
            .map((meal) => {

              let staticMealData =
                staticHotelData?.meals.find(
                  (staticMeal) => {
                    return staticMeal.code == meal.code;
                  }
                );

              let discountData: {
                amount: number;
                type: 'percent' | 'fixed';
                alreadyApplied: boolean;
              } | undefined = {
                amount: 0,
                type: 'percent',
                alreadyApplied: false
              };

              if (rateInfo.isOffer && meal.totalPriceModifier) {
                var discountInfo = meal.totalPriceModifier;

                var amount = 0;
                discountInfo.forEach((modifier: PriceModifier) => {
                  if (modifier.amount < 0) {
                    modifier.amount *= -1;
                  }

                  amount += (modifier.priceModifierTypeText == 'Discount') ? modifier.amount : 0;

                  discountData = {
                    alreadyApplied: modifier.isAlreadyApplied,
                    amount: Number(doExchangeCurrency(currency, userCurrency, amount ?? 0).toFixed(2)),
                    type: modifier.amountType
                  }
                });
              } else {
                discountData = undefined;
              }

              // PVP = 0
              // NET = 1

              var isPvp = meal?.price?.priceType === 0;

              const pvp = meal?.price?.pvpPrice;
              const net = meal?.price?.netPrice;
              priceFrom = isPvp ? (pvp?.amount ?? net?.amount ?? 0) : (net?.amount ?? pvp?.amount ?? 0);
              currency = isPvp ? (pvp?.currencyIsoCode ?? net?.currencyIsoCode ?? "") : (net?.currencyIsoCode ?? pvp?.currencyIsoCode ?? "");


              //Aplicamos conversión en caso de existir
              if (currency && currency !== userCurrency) {
                priceFrom = doExchangeCurrency(currency, userCurrency, priceFrom);
                currency = userCurrency;
              }

              priceFrom = Number.parseFloat(priceFrom.toFixed(2));

              if (priceRoomFrom > priceFrom) {
                priceRoomFrom = priceFrom;
              }


              //mapeo de los regimenes
              const allRegimesMapped = regimes.filter(r => regimesHotelIds.includes(r.id));

              const matchedRegime = allRegimesMapped.find(r => r.integrationCode === meal.code);
              const mappedNameRegime =
                matchedRegime?.names.find(
                  n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase()
                )?.value ?? ("N/A" + ` (${meal.code})`);


              meals.push({
                priceBreakdown: meal.priceBreakdown?.map((night) => ({
                  date: new Date(night.priceDate),
                  price: {
                    currency: userCurrency,
                    amount: Number.parseFloat(
                      doExchangeCurrency(currency, userCurrency, night.totalPrice.amount).toFixed(2)
                    ),
                  },
                })),

                rateKey: meal.rateKey,
                code: meal.code,
                name: mappedNameRegime,

                pvp: {
                  currency: userCurrency,
                  amount: pvp
                    ? Number.parseFloat(doExchangeCurrency(pvp.currencyIsoCode, userCurrency, pvp.amount).toFixed(2))
                    : 0,
                },
                net: {
                  currency: userCurrency,
                  amount: net
                    ? Number.parseFloat(doExchangeCurrency(net.currencyIsoCode, userCurrency, net.amount).toFixed(2))
                    : 0,
                },
                commission: {
                  currency: currency,
                  amount: Number.parseFloat(doExchangeCurrency(meal.price.commission?.currencyIsoCode ?? currency, userCurrency, meal.price.commission?.amount ?? 0).toFixed(2)),
                },
                isPvp: isPvp,
                discount: discountData
              });
            });

          // Recoger additionalInfo de los meals (la API lo pone a nivel de meal, no de rate)
          var rawAdditionalInfo: any[] = [];
          rateInfo.meals.forEach((meal: any) => {
            if (meal.additionalInfo && meal.additionalInfo.length > 0) {
              meal.additionalInfo.forEach((info: any) => {
                // Evitar duplicados por messageCode
                const code = info.MessageCode ?? info.messageCode ?? '';
                if (!rawAdditionalInfo.some((existing: any) => (existing.MessageCode ?? existing.messageCode ?? '') === code && code !== '')) {
                  rawAdditionalInfo.push(info);
                }
              });
            }
          });

          if (rateInfo.isNoRefundable) {
            rawAdditionalInfo.push({
              messageType: 0,
              messageCode: '',
              message: `Tarifa no reembolsable`,
              alertType: 2  // Error/Danger
            });
          }

          console.log("additionalInfo raw:", rawAdditionalInfo);
          var additionalInfo = rawAdditionalInfo.map((info: any) => ({
            messageType: info.MessageType ?? info.messageType,
            messageCode: info.MessageCode ?? info.messageCode,
            message: info.Message ?? info.message,
            alertType: info.AlertType ?? info.alertType,
          }));


          let cancellationPolicies = {
            policies: [] as {
              refundable: boolean;
              currency: string;
              deadLine: Date;
              penalty: number;
              code: string;
            }[],
            description: "",
          };


          rateInfo?.meals.forEach((meal: any) => {
            meal.cancellationPolicies.forEach((policy: CancellationPolicy) => {
              let amount = 0;


              switch (policy.cancellationPolicyType) { // 0 es pvp/ 1 es neto
                case 0: // Percent
                  amount = Number((policy.amount * 0.01 * ((meal.price.priceType == 0 ? meal.price.pvpPrice.amount : meal.price.netPrice.amount))).toFixed(2));
                  break;
                case 1: // Fix
                  amount = Number(policy.amount.toFixed(2));
                  break;
                case 2: // Nights   
                  /*
                       NoApply = 0,
                       Average = 1,
                       FirstNight = 2,
                       LastNight = 3,
                       MostExpensiveNight = 4,
                       CheapestNight = 5
                   */
                  let nightPrice = 0;
                  const breakdown = meal?.priceBreakdown ?? [];
                  const nights = breakdown.length;
                  switch (policy.penaltyNightType) {

                    case 1: // Average
                      nightPrice = breakdown.length ? breakdown.reduce((acc: number, curr: any) => acc + (curr?.totalPrice?.amount ?? 0), 0) / breakdown.length : 0; break;
                    case 2: // FirstNight
                      nightPrice = breakdown[0]?.totalPrice?.amount ?? 0;
                      break;
                    case 3: // LastNight
                      nightPrice = breakdown[breakdown.length - 1]?.totalPrice?.amount ?? 0;
                      break;
                    case 4: // MostExpensiveNight
                      nightPrice = breakdown.length ? Math.max(...breakdown.map((n: any) => n?.totalPrice?.amount ?? 0)) : 0;
                      break;
                    case 5: // CheapestNight
                      nightPrice = breakdown.length ? Math.min(...breakdown.map((n: any) => n?.totalPrice?.amount ?? 0)) : 0;
                      break;
                  }

                  // Aquí podrías calcular el importe basado en las noches si es necesario
                  amount = nightPrice * policy.amount; // Asignar un valor por defecto o calcularlo

                  break;
              }


              var newPolicy = {
                refundable: rateInfo.isNoRefundable,
                currency: userCurrency,
                deadLine: policy.deadLine
                  ? new Date(policy.deadLine + "Z")// esto es necesario, para que se guarde la hora local
                  : new Date(),
                penalty: Number(doExchangeCurrency(currency, userCurrency, amount).toFixed(2)),
                code: meal.code
              }

              cancellationPolicies.policies.push(newPolicy);
            })
          });

          const rate: RoomRate = {
            meals: meals,
            name: rateInfo.name ?? "N/D (7) (Code)",
            dates: [dayjs(), dayjs()],
            additionalInfo: additionalInfo,
            isOffer: rateInfo.isOffer,
            cancelPolicies: cancellationPolicies,
            isNoRefundable: rateInfo.isNoRefundable,
            depositInfo: rateInfo.depositInfo
    ? {
        type: rateInfo.depositInfo.depositType === DepositType.Percent ? 'percent' : 'fixed',
        amount: rateInfo.depositInfo.amount,
        beforeDate: new Date(rateInfo.depositInfo.beforeDate + "Z"), // igual que con deadLine
      }
    : undefined,
          };

          return rate;
        });

      var roomCode = roomAvailability.roomCode;

      let adjustedQuota = roomAvailability.quota;
      const currentIndex = Number.parseInt(String(roomAvailability.roomIndex));

      // Si la habitación ha sido seleccionada en otra roomIndex adyacente (±1), y es el mismo roomCode, ajustamos
      Object.entries(selectedRoomsByIndex).forEach(([indexStr, selectedCode]) => {
        const index = parseInt(indexStr);
        if (
          index !== currentIndex &&
          selectedCode === roomAvailability.roomCode
        ) {
          adjustedQuota = adjustedQuota - 1;
        }
      });

      if (adjustedQuota <= 0) {
        return;
      }


      // mapeo de noombre de habitaciones
      const allRoomsMapped = rooms.filter(r => roomHotelIds.includes(r.id));
      const matchedRoom = allRoomsMapped.find(r => r.integrationCode === roomCode);
      const mappedRoomName =
        matchedRoom?.names.find(
          n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase()
        )?.value ?? `Room N/M (${roomCode})`;


      // mapeo de servicios de la habitación
      let servicesRoomId = matchedRoom?.services ?? [];
      let servicesInfo = allServices.filter(s => servicesRoomId.includes(s.id));
      let services: Array<{ icon: string, name: string }> = servicesInfo.map(s => {
        const translatedName = s.name.find(n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase())?.value || "";
        return {
          icon: s.icon,
          name: translatedName
        };
      });

      //descripciones
      // Normalizamos para comparar sin espacios ni mayúsculas
      const LD = staticRoomData?.largeDescription ?? "";
      const SD = staticRoomData?.shortDescription ?? "";

      const normalizedLD = LD.trim().toLowerCase();
      const normalizedSD = SD.trim().toLowerCase();

      let finalShortDescription = SD || "SD N/M";
      let finalDescription = LD || "LD N/M";

      // Si son iguales → description se vacía para no mostrarlo
      if (normalizedLD !== "" && normalizedLD === normalizedSD) {
        finalDescription = "";
      }



      let roomData: Room = {
        code: roomAvailability.roomCode,
        beds: staticRoomData?.roomBeds?.length ?? 0,
        images: staticRoomImages ?? [],
        name: mappedRoomName,
        price: {
          currency: userCurrency,
          amount: priceRoomFrom,
        },
        remainingRooms: adjustedQuota,
        services: services,
        description: finalDescription,
        shortDescription: finalShortDescription,
        isNoRefundable: roomAvailability.rates.some(r => r.isNoRefundable)
      };

      result.push(
        <RoomCard
          key={`${roomData.code}-${currentIndex}-${_index}`}
          roomIndex={Number.parseInt(String(roomAvailability.roomIndex))}
          room={roomData}
          roomRates={rates}
          nights={0} // diferencia entre checkin y checkout ?
          modals={{
            showImages: (_props) => {
              modal.show('room-modal', roomData)
            },
            showRoomInfo: () => {
              modal.show('room-modal', roomData)
            },

            showRateInfo: (roomData: Omit<Room, 'beds'>, rateInfo: RoomRate, selectedMeal: Meal) => {

              if (!selectedMeal) {
                return false;
              }
              rateInfo.dates = [checkIn, checkOut]; // Asignar fechas por defecto, se pueden cambiar en el modal

              // Filtrar solo las políticas de cancelación que coinciden con selectedMeal.code
              const filteredCancelPolicies = {
                ...rateInfo.cancelPolicies,
                policies: rateInfo.cancelPolicies.policies
                  .sort((a, b) => new Date(a.deadLine).getTime() - new Date(b.deadLine).getTime()) // Ordenar por fecha de vencimiento
                  .filter(policy => (policy as Policy).code === selectedMeal.code) // este es nuestro Policy definido, no del componente 
                  .map(policy => ({
                    ...policy,
                    code: (policy as Policy).code // Nos aseguramos de que 'code' esté presente
                  }))
              };


              // Pasar el rateInfo filtrado al modal
              modal.show('room-rate-modal', {
                rateData: { ...rateInfo, cancelPolicies: filteredCancelPolicies },
                mealData: selectedMeal,
                roomName: roomData.name
              });
            }

          }}

          handleBooking={function (
            room: Omit<Room, "beds">,
            meal: Meal,
            rate: RoomRate
          ): Promise<void> {
            onSelectRoom(room, meal, rate);
            return Promise.resolve();
          }}
        />
      );
    });

  result.sort((a, b) => {
    const priceA = a.props.room?.price?.amount ?? Number.MAX_SAFE_INTEGER;
    const priceB = b.props.room?.price?.amount ?? Number.MAX_SAFE_INTEGER;
    return priceA - priceB;
  });

  // Habitaciones del paso actual con errorCode: no son reservables. Se añaden después de las disponibles
  // (ya ordenadas por precio), deshabilitadas, sin tarifas y con un ribbon que indica el motivo.
  // Usan el mismo mapeo de datos estáticos / appConfig que las disponibles (nombre, imágenes, servicios y descripciones).
  errorRoomsData.forEach((roomAvailability: RoomAvailability, _index: number) => {
    const roomCode = roomAvailability.roomCode;
    const currentIndex = Number.parseInt(String(roomAvailability.roomIndex));

    const hotelData: Hotel | undefined = hotelAvailability.hotels?.find(
      (hotel) => {
        return hotel.code == hotelCode;
      }
    );

    const staticHotelData = hotelData?.hotelStaticData?.[0];

    const staticRoomData = staticHotelData?.rooms.find(
      (room: RoomStaticData) => {
        return room.code == roomCode;
      }
    );

    const staticRoomImages: string[] = staticRoomData?.images?.sort((i1, i2) => i1.order - i2.order).map((image: Image) => image.url ?? "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg") || ["https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"];

    // mapeo de nombre de habitaciones
    const allRoomsMapped = rooms.filter(r => roomHotelIds.includes(r.id));
    const matchedRoom = allRoomsMapped.find(r => r.integrationCode === roomCode);
    const mappedRoomName =
      matchedRoom?.names.find(
        n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase()
      )?.value ?? `Room N/M (${roomCode})`;

    // mapeo de servicios de la habitación
    const servicesRoomId = matchedRoom?.services ?? [];
    const servicesInfo = allServices.filter(s => servicesRoomId.includes(s.id));
    const services: Array<{ icon: string, name: string }> = servicesInfo.map(s => {
      const translatedName = s.name.find(n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase())?.value || "";
      return {
        icon: s.icon,
        name: translatedName
      };
    });

    //descripciones
    const LD = staticRoomData?.largeDescription ?? "";
    const SD = staticRoomData?.shortDescription ?? "";

    const normalizedLD = LD.trim().toLowerCase();
    const normalizedSD = SD.trim().toLowerCase();

    const finalShortDescription = SD || "SD N/M";
    let finalDescription = LD || "LD N/M";

    // Si son iguales → description se vacía para no mostrarlo
    if (normalizedLD !== "" && normalizedLD === normalizedSD) {
      finalDescription = "";
    }

    const roomData: Room = {
      code: roomCode,
      beds: staticRoomData?.roomBeds?.length ?? 0,
      images: staticRoomImages ?? [],
      name: mappedRoomName,
      price: {
        currency: userCurrency,
        amount: 0, // sin tarifas no hay precio
      },
      remainingRooms: 0,
      services: services,
      description: finalDescription,
      shortDescription: finalShortDescription,
      isNoRefundable: (roomAvailability.rates ?? []).some(r => r.isNoRefundable)
    };

    result.push(
      <RoomCard
        key={`error-${roomCode}-${currentIndex}-${_index}`}
        roomIndex={currentIndex}
        room={roomData}
        roomRates={[]} // sin tarifas: el componente solo pinta la cabecera con el ribbon (nunca pasar una tarifa con meals vacío)
        nights={0}
        error={getRoomErrorRibbon(roomAvailability.errorCode ?? "")}
        disabled
        modals={{
          showImages: () => {
            modal.show('room-modal', roomData)
          },
          showRoomInfo: () => {
            modal.show('room-modal', roomData)
          },
          showRateInfo: () => {
            // sin tarifas no hay información de tarifa que mostrar
          }
        }}
        handleBooking={() => Promise.resolve()} // no reservable
      />
    );
  });

  return result;
}